<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Role</h4>
              <div v-if="action !== 'new'" class="form-role row mb-4">
                <label class="col-form-label col-lg-2">ID</label>
                <label class="col-form-label col-lg-8">{{
                  createModel.id
                }}</label>
              </div>
  
              <validationObserver ref="addRoleForm">
                <!-- <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset"> -->
                <div class="form-role row mb-4">
                  <label class="col-form-label col-lg-2">Sequence</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="sequence"
                      name="Sequence"
                      :rules="{
                        required: true,
                      }"
                    >
                      <b-form-input
                        id="sequence"
                        value="42"
                        type="number"
                        name="sequence"
                        v-model="createModel.sequence"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) && createModel.sequence,
                        }"
                      ></b-form-input>
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-role row mb-4">
                  <label class="col-form-label col-lg-2">Name(TH)</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="displayname"
                      name="Display Name"
                      :rules="{
                        required: true,
                        duplicateName: [isDuplicate.th, 'ชื่อ Role ห้ามซ้ำในระบบ'],
                      }"
                    >
                      <input
                        id="displayname"
                        name="displayname"
                        v-model="createModel.display_name.th"
                        type="text"
                        class="form-control"
                        placeholder="Name"
                        maxlength="30"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.display_name.th,
                        }"
                        v-on:keyup="onValidateDisplayname('th')"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-role row mb-4">
                  <label class="col-form-label col-lg-2">Name(EN)</label>
                  <div class="col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      ref="displayname"
                      name="Display Name"
                      :rules="{
                        required: true,
                        duplicateName: [isDuplicate.en, 'ชื่อ Role ห้ามซ้ำในระบบ'],
                      }"
                    >
                      <input
                        id="displayname"
                        name="displayname"
                        v-model="createModel.display_name.en"
                        type="text"
                        class="form-control"
                        placeholder="Name"
                        maxlength="30"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) &&
                            createModel.display_name.en,
                        }"
                        v-on:keyup="onValidateDisplayname('en')"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-role row mb-4">
                  <label class="col-form-label col-lg-2">Description</label>
                  <div class="col-lg-8">
                    <input
                      id="role_description"
                      name="role_description"
                      v-model="createModel.description"
                      type="text"
                      class="form-control"
                      placeholder="Description"
                    />
                  </div>
                </div>
  
                <div class="row">
                  <label class="col-form-label col-lg-2">สถานะ</label>
                  <div class="col-form-label col-lg-8">
                    <div class="row col-lg-12">
                      <b-form-radio
                        v-model="createModel.status"
                        name="status"
                        class="custom-control custom-radio custom-radio-info mb-3"
                        value="Active"
                        style="margin-right: 10px"
                        >Active</b-form-radio
                      >
                      <b-form-radio
                        v-model="createModel.status"
                        name="status"
                        class="custom-control custom-radio custom-radio-info mb-3"
                        value="Inactive"
                        style="margin-right: 10px"
                        >Inactive</b-form-radio
                      >
                    </div>
                  </div>
                </div>
                <div class="form-role mb-4 text-center">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="onSubmit"
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="onConfirmReset"
                    >
                      Reset
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="onCancel()"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <!-- </form> -->
              </validationObserver>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </Layout>
  </template>
  
  <script>
  import Vue from "vue";
  import DatePicker from "vue2-datepicker";
  import Swal from "sweetalert2";
  
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { required, minLength, maxLength } from "vuelidate/lib/validators";
  import roleService from "@/helpers/service/role-provider";
  import { eventBus } from "@/main.js";
  import {
    StatusEnum,
    ChannelAllowEnum,
    ChannelAllowTypeEnum,
  } from "@/enum/role.enum.js";
  import { applicationComputed } from "@/state/helpers";
  /**
   * Projects-create component
   */
  export default {
    page: {
      title: "Create New Role",
      meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
      return {
        dropzoneOptions: {
          url: "https://httpbin.org/post",
          thumbnailWidth: 120,
          maxFilesize: 0.5,
          headers: { "My-Awesome-Header": "header value" },
          addRemoveLinks: true,
        },
        id: "",
        action: "new",
        title: "Create New",
        items: [
          {
            text: "Home",
            href: "/",
          },
          {
            text: "Role",
            href: "/Roles",
          },
          {
            text: "Create New",
            active: true,
          },
        ],
        createModel: {
          id: 0,
          sequence: 0,
          display_name: {
            th: '',
            en: ''
          },
          display_name_old: {
            th: '',
            en: ''
          },
          status: StatusEnum.ACTIVE,
          description: ''
        },
        isDuplicate: {
            th: false,
            en: false
        },
      };
    },
    computed: {
      ...applicationComputed,
    },
    created: function () {
      this.id = this.$route.params.id;
      if (this.id === "new") {
        this.action = "new";
        this.title = "Create";
      } else {
        this.action = "edit";
        this.title = "Edit";
      }
    },
    mounted: function () {
      if (this.action === "edit") {
        this.getDetail();
      }
    },
    methods: {
      async getDetail() {
        let result = await roleService.getRoleAsync(
          this.GET_APPLICATION_SELECTED.id,
          this.id
        );
  
        //  console.log(result);
        if (result.status === 200) {
          this.createModel = result.data;
          this.createModel.display_name_old = result.data.display_name;
        } else if (result.response.status === 404) {
          console.log("error", result.response.data.message);
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
      },
      async onSubmit() {
        this.$refs.addRoleForm.validate().then(async (result) => {
          if (result) {
            if (this.action === "new") {
              let result = await roleService.createRoleAsync(
                this.GET_APPLICATION_SELECTED.id,
                this.createModel
              );
              if (result.status === 201) {
                // eventBus.$emit("info-modal", "เพิ่มข้อมูลสำเร็จ");
                Vue.swal({
                  position: "top-end",
                  icon: "success",
                  title: "Your work has been saved",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.$router.push({
                  path: "/Roles",
                });
                // this.clearForm();
              } else {
                eventBus.$emit("error-modal", result.response.data.message);
              }
            } else {
              let result = await roleService.updateRoleAsync(
                this.GET_APPLICATION_SELECTED.id,
                this.id,
                this.createModel
              );
              if (result.status == 204) {
                // eventBus.$emit("info-modal", "แก้ไขข้อมูลสำเร็จ");
                Vue.swal({
                  position: "top-end",
                  icon: "success",
                  title: "Your work has been saved",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.$router.push({
                  path: "/Roles",
                });
              } else {
                eventBus.$emit("error-modal", result.response.data.message);
              }
            }
          }
        });
      },
      onConfirmReset() {
        this.$utils
          .confirmAlertDisplay(
            `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
            ""
          )
          .then((result) => {
            if (result) {
              // console.log("mode", this.mode);
              if (this.action === "new") {
                this.createModel = {
                  id: 0,
                  sequence: 0,
                  display_name: "",
                  display_name_old: "",
                  status: StatusEnum.ACTIVE,
                };
                this.$nextTick(
                  () => this.$refs.addRoleForm.reset(),
                  this.$refs.addRoleForm.$children[0].reset()
                );
              } else {
                this.getDetail();
              }
            }
          });
      },
      onCancel() {
        this.$router.push({
          path: "/Roles",
        });
      },
      async onValidateDisplayname(lang) {
        //  console.log('onValidateDisplayname', lang)
        let display_name = ""
        let old_display_name = ""
        if (lang === 'th') {
            display_name =  this.createModel.display_name.th
            old_display_name = this.createModel.display_name_old.th
        } else {
            display_name =  this.createModel.display_name.en
            old_display_name = this.createModel.display_name_old.en
        }

        if (this.$validate.isTrimValid(display_name)) {
            display_name = display_name.trim()
          if (this.action === "edit" && old_display_name == display_name) {
            return;
          }

          let params = new URLSearchParams();
          if(lang === 'th') {
            params.append("display_name_th", display_name);
          } else {
            params.append("display_name_en", display_name);
          }
          
          if (this.action !== "new") {
            params.append("id", this.id);
          }
          let result = await roleService.headRoleAsync(
            this.GET_APPLICATION_SELECTED.id,
            params
          );
          if (result.status === 200) {
            if(lang === 'th') {
                this.isDuplicate.th = true;
            } else {
                this.isDuplicate.en = true;
            }
          } else if (result.response.status === 404) {
            if(lang === 'th') {
                this.isDuplicate.th = false;
            } else {
                this.isDuplicate.en = false;
            }
          } else {
            if (result.response.data.message) {
              eventBus.$emit("error-modal", result.response.data.message);
            } else {
              eventBus.$emit("error-modal", "Bad request: Unkonw error");
            }
          }
        }
      },
      clearForm() {
        this.createModel = {
          id: 0,
          id_od: "",
          display_name: "",
          status: StatusEnum.ACTIVE,
          ownRoleStatus: true,
          create_info: {
            timestamp: "",
            user_id: "",
            user_name: "",
          },
          update_info: {
            timestamp: "",
            user_id: "",
            user_name: "",
          },
        };
      },
    },
  };
  </script>
  
  <style scoped>
  .switches-channel {
    margin-top: 13px;
  }
  </style>
  